import css from "./MultiSelect.module.css";

export type MultiSelectOption = {
  value: string;
  title: string;
  color?: string;
};

MultiSelect.defaultProps = {
  width: 140,
};
export function MultiSelect(props: {
  options: MultiSelectOption[];
  value: readonly string[];
  width: number;
  onChange: (vals: string[]) => void;
}) {
  return (
    <select
      multiple
      className={css.select}
      style={{ width: props.width }}
      value={props.value}
      onChange={(e) =>
        props.onChange(Array.from(e.target.selectedOptions).map((o) => o.value))
      }
    >
      {props.options.map((opt, i) => (
        <option
          key={i}
          className={css.option}
          style={{ color: opt.color }}
          value={opt.value}
        >
          {opt.title}
        </option>
      ))}
    </select>
  );
}
